<template>
  <div
    style="border-top-right-radius:0"
    :class="['extensions-container', { rounded: referredMessaged}]"
  >
    <div class="extentions-header">
      <div @click="toggleOffersView" :class="['extension-tab offers-tab', {['selected-extension']: openOfferView, ['referral-extension']: referredMessaged}]">
        <svg viewBox="0 0 512 512" class="sb-icon">
          <use xlink:href="#gift-icon"></use>
        </svg>
        track<br>offer
      </div>
      <div @click="setExtension(3)" :class="['extension-tab target-wallet-tab', {['selected-extension']: extensionType === 3 && !openOfferView}]">
        <svg viewBox="0 0 890.5 890.5" class="sb-icon">
          <use xlink:href="#wallet-icon"></use>
        </svg>
        target    <br>wallet
      </div>
      <div @click="setExtension(4)" :class="['extension-tab any-link-tab', {['selected-extension']: extensionType === 4 && !openOfferView}]">
        <svg viewBox="0 0 512.092 512.092" class="sb-icon">
          <use xlink:href="#link-icon"></use>
        </svg>
        any<br>link
      </div>
    </div>

    <transition name="fade" mode="out-in">
      <div v-if="extensionType === 0 && !openOfferView" class="data-description extension-instructions">
        select an icon above to add a link for a digital coupon, target a specific part of the wallet or link to any website
      </div>
      <offers
          v-else-if="openOfferView"
          :campaignSendTime="campaignSendTime"
          :isBudzAutoCampaign="isBudzAutoCampaign"
          :messageModuleName="messageModuleName"
          :referredMessaged="referredMessaged"
          :rewardId="rewardId"
          @configOfferInteractions="configUserInteractions"
          @setExtension="setExtension"
          @validOffer="updateValidOffer"></offers>
      <target-wallet
          v-else-if="extensionType === 3"
          :messageModuleName="messageModuleName"
          @passExtensionData="passExtensionData"
          @setExtension="setExtension"
          @validTarget="updateValidTarget"></target-wallet>
      <div class="wrapper" v-else-if="extensionType === 4">
        <div class="content">
          <any-link class="tab-content" :autocampaign-message-id="messageId" @setExtension="setExtension" />
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
  import AnyLink from '../Campaigns/extensions/any-link-old.vue'
  import { mapState } from 'vuex'
  import Offers from './Offers.vue'
  import TargetWallet from './TargetWallet.vue'

  export default {
    props: {
      campaignSendTime: String,
      isBudzAutoCampaign: Boolean,
      messageModuleName: String,
      previousUrls: Array,
      referredMessaged: Boolean,
    },

    name: 'Extensions',

    components: {
      TargetWallet,
      Offers,
      AnyLink
    },

    data() {
      return {
        extensionValid: null,
        offerIsSelected: false,
        type: null,
        validTarget: null,
        validOffer: true,
      }
    },

    methods: {
      configUserInteractions(componentInteractions) {
        this.$store.dispatch('UPDATE_STATE_OBJECT', {
          stateKey: 'noUserInteractions',
          itemKey: this.isCampaign ? 'offers' : `offers${this.messageId}`,
          itemObject: componentInteractions
        })
      },

      passExtensionData(data) {
        this.$emit('updateCampaign', data)
      },

      setExtension(ext) {
        this.type = ext
        const type = { _type: ext }
        this.$emit('updateCampaign', type)
        if (this.type !== 1) { this.configUserInteractions({}) }
        this.validateExtensions(true)
      },

      toggleOffersView() {
        this.offerIsSelected = !this.offerIsSelected
      },

      updateValidOffer(value) {
        this.validOffer = value
        this.validateExtensions()
      },

      updateValidTarget(value) {
        this.validTarget = value
        this.validateExtensions()
      },

      validateExtensions(isFromSetExtension) {
        switch (this.type) {
          case 0:
            this.extensionValid = true
            break
          case 1:
          case 4:
          case 5:
          case 6:
            this.extensionValid = isFromSetExtension ? true : this.validOffer
            break
          case 3:
            this.extensionValid = this.validTarget
            break
          case null:
            this.extensionValid = true
        }
        const validObject = this.extensionValid ? {} : { extensionsValid: this.extensionValid }
        this.$store.dispatch('UPDATE_STATE_OBJECT', {
          itemKey: this.isCampaign ? 'extensions' : `extensions${this.messageId}`,
          itemObject: validObject
        })
      },
    },

    created() {
      this.type = this.extensionType
    },

    computed: {
      isOffer: function() {
        return [1,5,6].includes(this.extensionType)
      },

      openOfferView: function() {
        return this.isOffer && this.rewardId || this.offerIsSelected
      },

      ...mapState({
        extensionType (state) { return state[this.messageModuleName]?.extensionType },
        isCampaign (state, getters) { return getters[`${this.messageModuleName}/isCampaign`] },
        messageId (state) { return state[this.messageModuleName]?.messageId },
        rewardId (state) { return state[this.messageModuleName]?.rewardId },
      }),
    },

    watch: {
      extensionType: function() {
        if ([0,3,4].includes(this.extensionType)) { this.offerIsSelected = false }
      }
    }
  }
</script>

<style scoped>
.extension-containers {
  position: relative;
}

.content {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  padding: 5px 10px;
}

.wrapper {
  position: absolute;
  top: 52px;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: auto;
}
</style>
